
import React, { useEffect, useState, useRef } from "react";
import { Link } from 'react-router-dom';
import { Navigate, NavLink } from "react-router-dom";

const HeaderBar: React.FC = (props) => {










    return (
        <div>
            <div className='flex px-2 bg-white rounded-md p-6 text-lg mb-6'>
                {/*<div className='w-2/4' style={{ paddingLeft: "10px", marginBottom: "10px", fontWeight: "bold" }} > {props.functionName} </div>*/}
                <div className='w-4/4 flex justify-start  mx-2 ' style={{ fontSize: "10px" }}>

                    <li className="flex items-center space-x-3">

                        {props.parentUrl !== undefined && props.parentUrl !== "" && (
                            <NavLink className='text-header-bar-blue font-bold' to={props.parentUrl}    >   {props.parentName} </NavLink>
                        )}
                        {props.url !== undefined && props.url !== "" && (
                            <>
                                <svg xmlns="http://www.w3.org/2000/svg" className="w-4 h-4" fill="none" viewBox="0 0 24 24" stroke="currentColor"
                                    strokeWidth="2">
                                    <path strokeLinecap="round" strokeLinejoin="round" d="M9 5l7 7-7 7" />
                                </svg>
                                <NavLink className='text-header-bar-blue font-bold underline' to={props.url}    >   {props.functionName} </NavLink></>
                        )}
                        {props.functionNameChild1 !== undefined && props.functionNameChild1 !== "" && (
                            <>
                                <svg xmlns="http://www.w3.org/2000/svg" className="w-4 h-4" fill="none" viewBox="0 0 24 24" stroke="currentColor"
                                    strokeWidth="2">
                                    <path strokeLinecap="round" strokeLinejoin="round" d="M9 5l7 7-7 7" />
                                </svg>
                                <NavLink className='text-header-bar-blue font-bold underline' to={props.urlChild1}    >   {props.functionNameChild1} </NavLink></>
                        )}


                    </li>

                </div>

            </div>

        </div>
    );
};


export default HeaderBar;
